module.exports = __webpack_public_path__ + "media/src/images/icons/pencil/blue-baf53df3c60fbc5826183b3745429717.svg";